module.exports = __webpack_public_path__ + "static/media/Inclusion-Jeny-Mathews-Thusoo.20394c7e.m4v";